






































































import Component from 'vue-class-component';
import { Prop, Emit, Ref } from 'vue-property-decorator';

import Webview from '@/webview';
import {
  dispatchGetHotCity,
  dispatchGetRegionList,
  dispatchGetLocation,
  dispatchGetDepartmentList,
  dispatchGetSearchConditionList,
  dispatchGetHospitalsType
} from '@/store/specialist';
import { IgetSearchConditionListFiltersChildren } from '@/store/specialist/index.d';
import {
  FILTER_TYPE_ENUM,
  IfilterVaule,
  ItreeSelect,
  IfilterRender,
  ItreeSelectItemChild,
  ItreeSelectItem,
  Idropdown,
  IdropdownValues,
  FILTER_TELESCOPE_ENUM
} from '@/pages/DoctorSearch/SearchFilter';
import { DropdownItem } from '@zyf2e/capui-mobile';

const CHINA_CODE = '100000';

@Component
export default class SearchFilter extends Webview {
  @Prop({
    type: Array,
    required: true
  })
  types!: FILTER_TYPE_ENUM[];

  @Prop({
    type: Object
  })
  value!: IfilterVaule;

  @Prop({
    type: String
  })
  defaultDepartmentId!: string;

  @Prop({
    type: Function,
    default: () => {
      // do nothing
    }
  })
  searchData!: Function;

  @Prop({
    type: Object
  })
  telescopeMap!: { [k: number]: string };

  @Prop({
    type: Boolean,
    default: true
  })
  useLoaction!: boolean;

  currentTreeSelect: Partial<ItreeSelect> = {};

  currentType!: FILTER_TYPE_ENUM;

  treeSelectDisplay = false;

  firstEntry = true;

  locationCity = '';

  renderMap: { [k: number]: IfilterRender } = {
    [FILTER_TYPE_ENUM.CITY]: {
      init: this.initArea,
      tree: {
        activeIndex: 0,
        activeId: ''
      },
      title: '全国',
      defaultTitle: '全国'
    },
    [FILTER_TYPE_ENUM.DEPARTMENT]: {
      init: this.getDepartmentList,
      tree: {
        activeIndex: 0,
        activeId: ''
      },
      title: '全部科室',
      defaultTitle: '全部科室'
    },
    [FILTER_TYPE_ENUM.CONDITION]: {
      init: this.getConditions,
      title: '筛选',
      defaultTitle: '筛选',
      dropdown: { options: [], isMuitl: true }
    },
    [FILTER_TYPE_ENUM.HOSPITALS_TYPE]: {
      init: this.getHospitalsType,
      title: '全部类型',
      defaultTitle: '全部类型',
      dropdown: { options: [] }
    }
  };

  @Ref('coditions')
  readonly coditions!: DropdownItem[];

  async created() {
    this.ZYToast.setOnceConfig({ noToast: true });

    await Promise.all(
      this.types.map(type => {
        if (type !== undefined) {
          return this.renderMap[type].init();
        }

        return Promise.resolve();
      })
    );
    this.ZYToast.clearOnceConfig();
    this.setDefaultDepartment();
  }

  async initArea() {
    try {
      // locationCity
      const [cities, { cities: hotCities }] = await Promise.all([
        dispatchGetRegionList(this.$store, { districtCode: CHINA_CODE }),
        dispatchGetHotCity(this.$store)
        // this.getLocation()
      ]);

      const items = [
        {
          text: '热门地区',
          children: [
            {
              text: '全国',
              id: ''
            },
            ...hotCities.map(
              (hotCity): ItreeSelectItemChild => ({
                text: hotCity.districtName,
                id: hotCity.districtName,
                parentIndex: 0,
                level: 2
              })
            )
          ]
        },
        ...cities.map(
          ({ districtName, districtCode }, index): ItreeSelectItem => ({
            text: districtName,
            id: districtCode,
            children: [
              {
                text: '全部',
                id: `${districtName}全部`,
                parentId: districtName,
                parentIndex: index + 1,
                parentText: districtName,
                level: 1
              }
            ]
          })
        )
      ];

      this.locationCity = this.location || '北京'; // locationCity

      const location = {
        text: this.locationCity,
        id: this.locationCity,
        isLocation: true,
        level: 2
      };

      this.$emit('onLocation', location);
      if (this.locationCity) {
        items[0].children.unshift(location as ItreeSelectItemChild);
      }
      this.$set(this.renderMap[FILTER_TYPE_ENUM.CITY].tree as ItreeSelect, 'items', items);
      if (this.useLoaction) {
        this.$set(this.renderMap[FILTER_TYPE_ENUM.CITY], 'title', this.locationCity);
      }
      if (!this.locationCity) {
        this.currentType = FILTER_TYPE_ENUM.CITY;
        this.setDropdownTitle('全国');
      }
    } catch (e) {
      // do nothing
    }
  }

  async getLocation() {
    let coordinates = { latitude: 0, longitude: 0 };
    try {
      coordinates = await this.adapter.getLocation();
    } catch (error) {
      // do nothing
    }
    const { latitude, longitude } = coordinates;
    let result = '';
    if (latitude && longitude) {
      const { city } = await dispatchGetLocation(this.$store, coordinates);
      result = city;
    }

    return result;
  }

  async getCities(activeIndex: number) {
    const { items = [] } = this.renderMap[FILTER_TYPE_ENUM.CITY].tree as ItreeSelect;
    const { children = [], id } = items[activeIndex];

    if (children.length === 1) {
      const cities = await dispatchGetRegionList(this.$store, { districtCode: id as string });

      items[activeIndex].children = items[activeIndex].children.concat(
        cities.map(
          ({ districtName }): ItreeSelectItemChild => ({
            text: districtName,
            id: districtName,
            parentIndex: activeIndex,
            level: 2
          })
        )
      );

      this.$set(this.renderMap[FILTER_TYPE_ENUM.CITY].tree as ItreeSelect, 'items', items);
    }
  }

  setDefaultDepartment() {
    if (!this.defaultDepartmentId) {
      return;
    }

    const tree = this.renderMap[FILTER_TYPE_ENUM.DEPARTMENT].tree as ItreeSelect;
    let resultItem!: ItreeSelectItemChild;

    tree.items.some(({ id, text, children }, index) => {
      if (!id) {
        return false;
      }

      const strId = id.toString();
      const str = this.defaultDepartmentId;
      if (this.defaultDepartmentId === strId || str.slice(0, strId.length) === strId) {
        tree.activeIndex = index;
        tree.activeId = parseInt(this.defaultDepartmentId, 0);
        let title = '';
        if (this.defaultDepartmentId === strId) {
          title = text;
          [resultItem] = children;
        } else {
          resultItem = (children.find(({ id: childId }) => childId === tree.activeId) || {}) as ItreeSelectItemChild;
          title = resultItem.text;
        }
        this.renderMap[FILTER_TYPE_ENUM.DEPARTMENT].title = title;
        return true;
      }

      return false;
    });

    if (resultItem) {
      this.currentType = FILTER_TYPE_ENUM.DEPARTMENT;
      this.selectedTree(resultItem);
    }
  }

  async getDepartmentList() {
    const { data: departments } = await dispatchGetDepartmentList(this.$store);

    const items = [
      {
        text: '全部科室',
        id: '',
        children: Array.prototype.concat([{ text: '全部', parentIndex: 0, parentText: '全部科室', id: '' }])
      },
      ...departments.map(
        ({ label, value, children = [] }, index): ItreeSelectItem => ({
          text: label,
          id: value,
          children: [
            {
              text: '全部',
              id: value,
              parentIndex: index + 1,
              parentText: label,
              level: 1
            },
            ...children.map(
              ({ label: childLable, value: childValue }): ItreeSelectItemChild => ({
                text: childLable,
                id: childValue,
                parentIndex: index + 1,
                level: 2
              })
            )
          ]
        })
      )
    ];

    this.$set(this.renderMap[FILTER_TYPE_ENUM.DEPARTMENT].tree as ItreeSelect, 'items', items);
  }

  openTree(type: FILTER_TYPE_ENUM) {
    this.currentType = type;
    const { tree } = this.renderMap[type];
    if (tree) {
      this.currentTreeSelect = tree;
      this.treeSelectDisplay = true;
    }
    if (this.firstEntry && this.useLoaction) {
      this.$set(this.currentTreeSelect, 'activeId', this.locationCity);
      this.$set(this.currentTreeSelect, 'activeIndex', 0);
      this.firstEntry = false;
    }

    if (this.telescopeMap) {
      this.telescope.trackEvent({ trackId: this.telescopeMap[type] });
    }
  }

  closeDropdown(type: FILTER_TYPE_ENUM) {
    const { dropdown } = this.renderMap[type];
    if (dropdown) {
      const { isConfirm } = dropdown;
      if (!isConfirm) {
        this.clearTempConditions();
      }

      dropdown.isConfirm = false;
    }
  }

  handleClickNav(activeIndex: number) {
    if (this.currentTreeSelect === this.renderMap[FILTER_TYPE_ENUM.CITY].tree) {
      this.getCities(activeIndex);
    }
  }

  selectedTree(data: ItreeSelectItemChild) {
    const { text, parentText } = data;

    this.setDropdownTitle(parentText || text);

    this.applyFilter({
      ...this.value,
      [this.currentType]: data
    });
    this.treeSelectDisplay = false;
  }

  @Emit('input')
  // eslint-disable-next-line class-methods-use-this
  applyFilter(newValue: IfilterVaule) {
    if (this.telescopeMap) {
      const map: { [k: number]: number } = {
        [FILTER_TYPE_ENUM.CITY]: FILTER_TELESCOPE_ENUM.SELECT_CITY,
        [FILTER_TYPE_ENUM.DEPARTMENT]: FILTER_TELESCOPE_ENUM.SELECT_DEPARTMENT,
        [FILTER_TYPE_ENUM.CONDITION]: FILTER_TELESCOPE_ENUM.SELECT_CONDITION
      };
      this.telescope.trackEvent({
        trackId: this.telescopeMap[map[this.currentType]],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        custom: { ...(newValue[this.currentType] as { [k: string]: any }) }
      });
    }

    return newValue;
  }

  async getConditions() {
    const { filters } = await dispatchGetSearchConditionList(this.$store);

    this.$set(this.renderMap[FILTER_TYPE_ENUM.CONDITION].dropdown as Idropdown, 'options', filters);
  }

  async getHospitalsType() {
    const { hospitalTypeList } = await dispatchGetHospitalsType(this.$store);

    const options = [
      {
        name: '医院类型',
        type: 1,
        children: [
          {
            label: '全部类型'
          },
          ...hospitalTypeList.map(({ id, name }) => ({
            id,
            label: name
          }))
        ]
      }
    ];

    this.$set(this.renderMap[FILTER_TYPE_ENUM.HOSPITALS_TYPE].dropdown as Idropdown, 'options', options);
  }

  // eslint-disable-next-line class-methods-use-this
  isSelectCodition({ values = {}, isMuitl }: Idropdown, type: number, id: number) {
    if (isMuitl) {
      return ((values[type] || []) as number[]).indexOf(id) > -1;
    }
    return values[type] === id;
  }

  selectCondition(type: number, { id, label }: IgetSearchConditionListFiltersChildren) {
    const dropdown = this.renderMap[this.currentType].dropdown as Idropdown;
    const { values = {}, isMuitl } = dropdown;

    let value: number | number[] = id;

    if (isMuitl) {
      value = (values[type] || []) as number[];
      const index = value.indexOf(id);
      if (index > -1) {
        value.splice(index, 1);
      } else {
        value.push(id);
      }
    } else {
      this.renderMap[this.currentType].tempTitle = label;
    }

    values[type] = value;

    this.$set(this.renderMap[this.currentType], 'dropdown', {
      ...dropdown,
      values
    });
  }

  setConditions() {
    const dropdown = this.renderMap[this.currentType].dropdown as Idropdown;

    const { tempTitle } = this.renderMap[this.currentType];

    if (tempTitle) {
      this.renderMap[this.currentType].title = tempTitle;
    }

    this.applyFilter(
      JSON.parse(
        JSON.stringify({
          ...this.value,
          [this.currentType]: dropdown.values as IdropdownValues
        })
      )
    );

    if (this.telescopeMap && this.currentType === FILTER_TYPE_ENUM.CONDITION) {
      this.telescope.trackEvent({ trackId: this.telescopeMap[FILTER_TELESCOPE_ENUM.CONDITION_CONFIRM] });
    }

    dropdown.isConfirm = true;
    this.toggleConditions(false);
    // 去掉，防止重复调用
    // this.searchData();
  }

  resetConditions() {
    const { defaultTitle } = this.renderMap[this.currentType];

    if (defaultTitle) {
      this.renderMap[this.currentType].title = defaultTitle;
    }

    if (this.telescopeMap && this.currentType === FILTER_TYPE_ENUM.CONDITION) {
      this.telescope.trackEvent({ trackId: this.telescopeMap[FILTER_TELESCOPE_ENUM.CONDITION_RESET] });
    }

    this.applyFilter({
      ...this.value,
      [this.currentType]: {}
    });

    this.toggleConditions(false);
    // 去掉，防止重复调用
    // this.searchData();
  }

  clearTempConditions() {
    const dropdown = this.renderMap[this.currentType].dropdown as Idropdown;

    this.$set(this.renderMap[this.currentType], 'dropdown', {
      ...dropdown,
      values: this.value[this.currentType]
    });
  }

  clear() {
    Object.entries(this.renderMap).forEach(([key, { defaultTitle }]) => {
      this.renderMap[parseInt(key, 0)].title = defaultTitle;
    });

    this.applyFilter({});
  }

  toggleConditions(show = true) {
    const index = this.types.indexOf(this.currentType);

    if (show && this.telescopeMap) {
      this.telescope.trackEvent({
        trackId: this.telescopeMap[this.currentType]
      });
    }

    this.coditions[index].toggle(show);
  }

  setDropdownTitle(title: string) {
    this.renderMap[this.currentType].title = title;
  }
}
